import { GuarantorDropDownSearch } from './components/GuarantorDropDownSearch';
interface CriteriaProps {
    onGuarantorLendingLimitsSearch: (id: number | undefined) => void;
}
export const Criteria: React.FC<CriteriaProps> = ({ onGuarantorLendingLimitsSearch }) => {
    return (
        <>
            <div className='lending-limits-criteria'>
                <GuarantorDropDownSearch onGurantorLendingLimitsSearch={onGuarantorLendingLimitsSearch} />
            </div>
        </>
    );
};
